var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewLink = function SvgNewLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.512
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.256 5.627c0 1.425.55 2.791 1.53 3.799a5.15 5.15 0 0 0 3.692 1.573A5.15 5.15 0 0 0 9.17 9.426a5.45 5.45 0 0 0 1.53-3.799c0-1.424-.55-2.79-1.53-3.798A5.15 5.15 0 0 0 5.478.256a5.15 5.15 0 0 0-3.693 1.573 5.45 5.45 0 0 0-1.53 3.798",
    transform: "matrix(1.82136 0 0 1.7705 .023 .036)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.781 4.672c.166.089.31.222.421.388s.185.359.216.564.018.415-.038.613a1.3 1.3 0 0 1-.282.525L4.95 8.061c-.215.243-.507.38-.811.38s-.597-.137-.812-.38a1.4 1.4 0 0 1-.336-.918c0-.345.121-.675.336-.919l.448-.507m3.405-.179.448-.507c.215-.244.336-.574.336-.919 0-.344-.121-.674-.336-.918a1.09 1.09 0 0 0-.812-.38c-.304 0-.596.137-.811.38L4.857 4.493c-.13.147-.226.327-.282.525a1.5 1.5 0 0 0-.038.613c.031.205.105.398.216.564s.255.299.421.388",
    transform: "matrix(1.82136 0 0 1.7705 .023 .036)"
  }))));
};
export default SvgNewLink;